import { useState, useEffect, useMemo } from 'react'

export interface LiffEnv {
  isIAB: boolean;
  isLiff: boolean;
  isLiffReady: boolean;
  baseUrl: string;
}

const isLineIAB = (): boolean => {
  return !liff?.isInClient() && !!liff?.getLineVersion()
}

export default function useLiff (): LiffEnv {
  const [liffEnv, setLiffEnv] = useState<LiffEnv>({
    isLiff: false,
    isLiffReady: false,
    isIAB: false,
    baseUrl: ''
  })

  useEffect(() => {
    if (typeof liff === 'undefined') return
    liff
      .ready
      .then(() => {
        let baseUrl: string
        try {
          baseUrl = `${new URL(liff.permanentLink.createUrl()).origin}/${liff.id}`
        } catch {
          baseUrl = window.location.origin
        }
        const env: LiffEnv = {
          ...liffEnv,
          isIAB: isLineIAB(),
          isLiff: liff.isInClient(),
          isLiffReady: true,
          baseUrl
        }
        setLiffEnv(env)
      })
      .catch((e) => {
        console.error('liff init error ->', e)
        const env: LiffEnv = {
          ...liffEnv,
          isIAB: isLineIAB(),
          baseUrl: window.location.origin
        }
        setLiffEnv(env)
      })
  }, [])

  return useMemo(() => liffEnv, [liffEnv])
}
